"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerCustomer = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
class PartnerCustomer extends common_1.MongoSubDocument {
}
exports.PartnerCustomer = PartnerCustomer;
//# sourceMappingURL=partner-customer.model.js.map